import {
    Component,
    Input,
    Output,
    EventEmitter,
    ElementRef,
    OnInit,
    OnChanges,
    SimpleChanges,
    AfterViewInit
} from '@angular/core';
import {TextItem} from './text-item';
import { SimpleMDEService } from '../../services/simplemde.service';
import {Globals} from "../../globals";

import $ from 'jquery/dist/jquery.js'

import {ImageItem} from "../image-item";

@Component({
  selector: 'app-text-item',
  templateUrl: './text-item.component.html',
  styleUrls: ['./text-item.component.css']
})
export class TextItemComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() textItem: TextItem;
  @Input() isSelected: boolean;
  @Input() previewMode: boolean;
  @Output() textItemAddPointEvent =  new EventEmitter<TextItem>();
  @Output() textItemSelectEvent =  new EventEmitter<TextItem>();
  @Output() textItemLinkImageEvent =  new EventEmitter<TextItem>();
  @Output() unlinkImageEvent =  new EventEmitter<TextItem>();
  @Output() textItemRemoveEvent =  new EventEmitter<TextItem>();
  @Output() textItemDuplicateEvent =  new EventEmitter<TextItem>();

  dragSelected: boolean = false;
  globalPreviewMode: boolean;

  state = 'view';
  mdeEditorObject: any;


  constructor(
      private elementRef: ElementRef,
      private simpleMdeService: SimpleMDEService,
      private globals: Globals
  ) { }

  ngOnInit() {
      this.textItem.textFormated = this.simpleMdeService.getHtml(this.textItem.text);
      this.globalPreviewMode = this.globals.previeModeStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (!changes.firstChange && changes.isSelected.currentValue ) {
      this.scrollTo();
    }

    // this.elementRef.nativeElement.querySelector('.text-content').innerHTML = '';
  }

  ngAfterViewInit() {
  }

  addPoint() {
      this.textItemAddPointEvent.emit(this.textItem);
      this.select();
  }

  edit() {
      this.state = 'editor';
      setTimeout( () => {
          this.mdeEditorObject = this.simpleMdeService.getEditor(this.elementRef.nativeElement.querySelector('textarea'));
      }, 100);
  }

  save() {
      this.textItem.text = this.simpleMdeService.getValue();
      this.textItem.textFormated = this.simpleMdeService.getHtml(this.textItem.text);
      this.simpleMdeService.unbind();
      this.state = 'view';
  }

  select() {
      this.textItem.isSelected = true;
  }

  selectActive() {
      this.textItemSelectEvent.emit(this.textItem);
  }

  remove() {
      this.textItemRemoveEvent.emit(this.textItem);
  }

  duplicate() {
      this.textItemDuplicateEvent.emit(this.textItem);
  }

  scrollTo() {
      $('#textItemContainer').animate({
          scrollTop: this.elementRef.nativeElement.offsetTop - $('#textItemContainer').get(0).offsetTop
      }, 1000);

      /**
      const rr = Math.round( (this.elementRef.nativeElement.offsetTop - document.getElementById('textItemContainer').scrollTop) / 40 ) ;

      let currentOffsetTop = document.getElementById('textItemContainer').scrollTop;

      let interval = setInterval( () => {
          currentOffsetTop = document.getElementById('textItemContainer').scrollTop + rr;
          if(currentOffsetTop > this.elementRef.nativeElement.offsetTop){
              document.getElementById('textItemContainer').scrollTop = this.elementRef.nativeElement.offsetTop;
              clearInterval(interval);
          }else{
              document.getElementById('textItemContainer').scrollTop = document.getElementById('textItemContainer').scrollTop + rr;
          }
      }, 10);
       **/
      // document.getElementById('textItemContainer').scrollTop = this.elementRef.nativeElement.offsetTop;
  }

  onDrop(e) {
      this.dragSelected = false;
      let img = new ImageItem();
      img.url = e.dataTransfer.getData('img-src');
      this.textItem.image = img;
      this.textItemLinkImageEvent.emit(this.textItem);
  }

  onDragOver(e) {
      e.preventDefault();
      this.dragSelected = true;
  }

  onDragLeave(e) {
      this.dragSelected = false;
  }

  unlinkImage() {
      this.unlinkImageEvent.emit(this.textItem);
      // this.textItem.image = null;
  }

}
